import Vue from "vue";
import axios from "axios";
import router from "@/router";

const _axios = axios.create({
  withCredentials: true,
});

const onRequest = async (config) => {
  // const { method, url } = config;
  return config;
};

const onResponse = async (response) => {
  /** 응답 실패 시 처리 */
  const isLoginErr = response?.data?.message?.includes(
    "로그인 상태를 확인해주세요"
  );
  if (isLoginErr) {
    router.push({ name: "Login" });
  }

  /** 세션인증 실패 시 리다이렉트 */
  const isSessionFail =
    response?.data.code === 4001 &&
    response?.data?.message?.includes("로그인을 확인해 주세요");

  if (isSessionFail) {
    Vue.prototype.$bus.$emit("loadingEnd");
    router.push({ name: "Login" });
  }

  return response;
};

const onErrorResponse = async (error) => {
  const { message } = error;
  // 서버 에러 시 리다이렉트 작업 활용 가능
  /* if (message === "에러메시지") {
    // 각각의 에러들 처리
  } */
  console.error(message);
  return Promise.reject(error);
};

_axios.interceptors.request.use(onRequest, (err) => Promise.reject(err));
_axios.interceptors.response.use(onResponse, onErrorResponse);

export default _axios;
